.panelContainer {
    position: relative;
}

.scrollArea {
    position: absolute;
    inset: 0;
}

.panelResizeHandle {
    background-color: var(--mantine-color-dark-5);
}

.panelResizeHandleHorizontal {
    width: 1px;
}

.panelResizeHandleVertical {
    height: 1px;
}

.panelResizeHandleHidden {
    height: 0;
}

.mainPanelContainer {
    padding-top: 1px;
    padding-bottom: 1px;
}
